import { IconPropsType } from '..';

export const BadgesIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11.25 6.19294L11.7639 9.19288L9.07032 7.77612L6.3767 9.19288L6.89069 6.19294L4.71105 4.06779L7.72278 3.62597L9.07032 0.899956L10.4179 3.63039L13.4296 4.07221L11.25 6.19294ZM13.9406 8.91896V11.6936L9.0983 13.6611L9.07032 13.6494L4.20001 11.695V8.91896L9.07032 10.8733L13.9406 8.91896ZM13.9406 12.3592V15.1324L9.0983 17.1L9.07032 17.0882L4.20001 15.1339V12.3592L9.07032 14.3136L13.9406 12.3592Z" />
  </svg>
);
